'use client'

import { FC } from 'react'

import { DesktopLighthouse, MobileLighthouse } from '@dfds-pax/shared-components/client'

interface ErrorPageProps {
  basketId?: string
  correlationId?: string
  errorCode?: string
  onBackToHomeClicked: () => void
  onReloadClicked: () => void
  resources: {
    apologise: string
    backToHomeButtonText: string
    message: string
    title: string
    tryAgainButtonText: string
  }
}

export const ErrorPage: FC<ErrorPageProps> = ({ basketId, correlationId, onBackToHomeClicked, onReloadClicked, resources }) => {
  const showDebugTools = typeof window !== 'undefined' && window.location.origin !== 'https://www.dfds.com'

  return (
    <>
      <div className="hidden sm:block">
        <DesktopLighthouse
          backgroundImageUrl="/assets_paxob/images/3840x1600_error_screen.svg"
          basketId={basketId}
          correlationId={correlationId}
          onBackToHomeClicked={onBackToHomeClicked}
          onReloadClicked={onReloadClicked}
          showDebugTools={showDebugTools}
          resources={resources}
        />
      </div>
      <div className="h-full sm:hidden">
        <MobileLighthouse
          backgroundImageUrl="/assets_paxob/images/360x820_error_screen.svg"
          basketId={basketId}
          correlationId={correlationId}
          onBackToHomeClicked={onBackToHomeClicked}
          onReloadClicked={onReloadClicked}
          showDebugTools={showDebugTools}
          resources={resources}
        />
      </div>
    </>
  )
}
